import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { pathWithSearchParams } from "utility/router";

const openedFromWithinTheApp = () => ((window.history.state?.idx as number | undefined) ?? 0) > 0;

export const useDialogClose = (fallbackPath: string) => {
  const navigate = useNavigate();

  return useCallback(() => {
    if (openedFromWithinTheApp()) {
      navigate(-1);
      return;
    }

    navigate(pathWithSearchParams(fallbackPath), { replace: true });
  }, [navigate, fallbackPath]);
};
